import React, { useState } from 'react';

export default function ProspectoAsignacionModal({
  prospecto,
  asesores = [],
  supervisores = [],
  cargandoResponsables = false,
  errorResponsables = '',
  onRetryResponsables,
  onClose,
  onSubmit,
  saving = false,
}) {
  const [form, setForm] = useState({
    asesorId: prospecto?.asesorResponsableId || prospecto?.asesorId || '',
    supervisorId: prospecto?.supervisorId || '',
    motivo: '',
  });

  const update = (event) => {
    const { name, value } = event.target;
    setForm((actual) => ({ ...actual, [name]: value }));
  };

  const submit = (event) => {
    event.preventDefault();
    onSubmit?.({
      asesorId: form.asesorId || null,
      supervisorId: form.supervisorId || null,
      motivo: form.motivo.trim() || null,
    });
  };

  return (
    <div className="crm-prospectos-modal-overlay" role="presentation" onMouseDown={onClose}>
      <section className="crm-prospectos-modal" role="dialog" aria-modal="true" onMouseDown={(event) => event.stopPropagation()}>
        <div className="crm-prospectos-modal-head">
          <div>
            <p className="crm-prospectos-eyebrow">Prospecto</p>
            <h2>Reasignar responsable comercial</h2>
          </div>
          <button type="button" onClick={onClose} disabled={saving} aria-label="Cerrar">x</button>
        </div>
        <form onSubmit={submit} className="crm-prospectos-modal-body">
          <p className="crm-prospectos-feedback is-info">
            Esta accion cambia quien dara seguimiento al prospecto. No modifica al asesor que origino la oportunidad.
          </p>
          <label>
            <span>Nuevo asesor responsable</span>
            <select name="asesorId" value={form.asesorId} onChange={update} disabled={cargandoResponsables}>
              <option value="">Sin asignar</option>
              {asesores.map((asesor) => (
                <option key={asesor.id} value={asesor.id}>{asesor.nombre}</option>
              ))}
            </select>
            {cargandoResponsables ? <small>Cargando responsables...</small> : null}
          </label>
          <label>
            <span>Supervisor responsable</span>
            <select name="supervisorId" value={form.supervisorId} onChange={update} disabled={cargandoResponsables}>
              <option value="">Sin supervisor</option>
              {supervisores.map((supervisor) => (
                <option key={supervisor.id} value={supervisor.id}>{supervisor.nombre}</option>
              ))}
            </select>
            {cargandoResponsables ? <small>Cargando responsables...</small> : null}
          </label>
          {errorResponsables ? (
            <p className="crm-prospectos-feedback is-error">
              <span>{errorResponsables}</span>
              {onRetryResponsables ? <button type="button" onClick={onRetryResponsables}>Reintentar</button> : null}
            </p>
          ) : null}
          <label>
            <span>Motivo de reasignacion</span>
            <textarea name="motivo" value={form.motivo} onChange={update} rows="3" />
          </label>
          <div className="crm-prospectos-modal-actions">
            <button type="submit" className="is-primary" disabled={saving}>{saving ? 'Guardando...' : 'Reasignar'}</button>
            <button type="button" onClick={onClose} disabled={saving}>Cancelar</button>
          </div>
        </form>
      </section>
    </div>
  );
}
